{
    "SSO_Login_Title": "Accesso singolo (SSO)",
    "SSO_Login_Description": "Attendere per convalidare i dati dell'utente. Non dovrebbe volerci molto.",
    "SSO_Login_Error": "Siamo spiacenti, non siamo in grado di localizzarla. Riprovare. Se il problema persiste, contattare l'amministratore dell'applicazione.",
    "SSO_MissingCode_Error": "Spiacente, qualcosa è andato storto. Riprovare. Se il problema persiste, contattare l'amministratore dell'applicazione.",
    "NAME": "SSOLanguage"
}